// extracted by mini-css-extract-plugin
module.exports = {"button":"Password_button__AsmvZ","buttons":"Password_buttons__3Ny22"};